import React from 'react'
import { Backdrop } from '@material-ui/core'

import PropTypes from 'prop-types'
import { CircularProgress } from 'asterX-UIkit/Loaders/index'

const LoaderBackdrop = ({ loading }) => {
  return (
    loading && (
      <Backdrop open={loading} style={{ zIndex: 99999 }}>
        <CircularProgress />
      </Backdrop>
    )
  )
}
export default LoaderBackdrop
LoaderBackdrop.propTypes = {
  loading: PropTypes.bool
}
